import { CareLineService } from '../../core/http/service/CareLineService';
import { CategoryService } from '../../core/http/service/CategoryService';
import { ExamService } from '../../core/http/service/ExamService';
import { PersonCareLineService } from '../../core/http/service/PersonCareLineService';
import { ProcedureService } from '../../core/http/service/ProcedureService';
import { VitalSignService } from '../../core/http/service/VitalSignService';
import BaseResponse from '../../models/core/BaseResponse';
import CareLine from '../../models/core/careLine/CareLine';
import Category from '../../models/core/careLine/Category';
import Exam from '../../models/core/careLine/Exam';
import Procedure from '../../models/core/careLine/Procedure';
import VitalSign from '../../models/core/careLine/VitalSign';
 
export const RESET = 'RESET';
export const FETCH_CARE_LINES = 'FETCH_CARE_LINES';
export const FETCH_DROPDOWN_DATA = 'FETCH_DROPDOWN_DATA';

const sendToAnalytics = (action: string = '', error: any = null) =>{
    console.error(action, error); 
}
 
export const fetchCareLines = ()=>{
    const service: CareLineService = new CareLineService()
    return async (dispatch: any)=>{ 
        try{ 
            const response: any = await service.getCareLines()
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data);
            const careLines: CareLine[] = []
            baseResponse.data.forEach((data: any)=>{
                careLines.push(new CareLine().fromJSON(data))
            })

            dispatch({ 
                type: FETCH_CARE_LINES, 
                careLines: careLines
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
};

export const fetchActiveCareLines = ()=>{
    const service: CareLineService = new CareLineService()
    return async (dispatch: any)=>{ 
        try{ 
            const response: any = await service.getCareLines()
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data);
            const careLines: CareLine[] = []
            baseResponse.data.forEach((data: any)=>{
                if(!data.inativo){
                    careLines.push(new CareLine().fromJSON(data))
                }
            })

            dispatch({ 
                type: FETCH_CARE_LINES, 
                careLines: careLines
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
};

export const fetchDropdownData = ()=>{
    const examService: ExamService = new ExamService();
    const categoryService: CategoryService = new CategoryService();
    const procedureService: ProcedureService = new ProcedureService();
    const vitalSignService: VitalSignService = new VitalSignService();

    return async (dispatch: any)=>{
        try{    
            const exams: Exam[] = []
            const categories: Category[] = []
            const procedures: Procedure[] = []
            const vitalSigns: VitalSign[] = []

            const examResponse: any = await examService.getAll()
            const baseExamResponse: BaseResponse<any> = new BaseResponse().fromJSON(examResponse.data)
            baseExamResponse.data.forEach((d: any)=>{
                exams.push(new Exam().fromJSON(d))
            })
            
            const categoryResponse: any = await categoryService.getAll()
            const basecategoryResponse: BaseResponse<any> = new BaseResponse().fromJSON(categoryResponse.data)
            basecategoryResponse.data.forEach((d: any)=>{
                categories.push(new Category().fromJSON(d))
            })

            const procedureResponse: any = await procedureService.getAll()
            const baseprocedureResponse: BaseResponse<any> = new BaseResponse().fromJSON(procedureResponse.data)
            baseprocedureResponse.data.forEach((d: any)=>{
                procedures.push(new Procedure().fromJSON(d))
            })

            const vitalSignsResponse: any = await vitalSignService.getAll()
            const basevitalSignsResponse: BaseResponse<any> = new BaseResponse().fromJSON(vitalSignsResponse.data)
            basevitalSignsResponse.data.forEach((d: any)=>{
                vitalSigns.push(new VitalSign().fromJSON(d))
            })

            dispatch({
                type: FETCH_DROPDOWN_DATA,
                exams: exams,
                categories: categories,
                procedures: procedures,
                vitalSigns: vitalSigns,
            })

        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const filterCareLineByName = (searchQuery: string)=>{
    const service: CareLineService = new CareLineService()
    return async (dispatch: any)=>{ 
        try{ 
            const response: any = await service.getCareLineByName(searchQuery)
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data);
            const careLinesFiltered: CareLine[] = []
            baseResponse.data.forEach((data: any)=>{
                careLinesFiltered.push(new CareLine().fromJSON(data))
            })

            dispatch({ 
                type: FETCH_CARE_LINES, 
                careLines: careLinesFiltered
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const registerCareLine = (careLine: CareLine)=>{
    const service: CareLineService = new CareLineService()
    return async (dispatch: any)=>{ 
        try{ 
            await service.registerCareLine(careLine)
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const updateCareLine = (careLine: CareLine, careLineId: string)=>{
    const service: CareLineService = new CareLineService()
    return async (dispatch: any)=>{ 
        try{ 
            await service.updateCareLine(careLine, careLineId)
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const activateOrDeactivateCareLine = (isActivate: boolean, careLineId: string)=>{
    const service: CareLineService = new CareLineService()
    return async (dispatch: any) => {
        try {
            if (isActivate) {
               await service.activateCareLine(careLineId)
            } else {
               await service.inactivateCareLine(careLineId)
            }
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

export const attachCareLineToPerson = (careLineId: string, atendimentoId: string | null, personId: string)=>{
    const service: PersonCareLineService = new PersonCareLineService()
    return async (dispatch: any) => {
        try {
            const body = {
                pessoaId: personId,
                linhaCuidadoId: careLineId,
                atendimentoId: atendimentoId
            }

            await service.attachCareLineToPerson(body);
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

export const detachCareLineFromPerson = (careLineId: string, personId: string)=>{
    const service: PersonCareLineService = new PersonCareLineService()
    return async (dispatch: any) => {
        try {
            const body = {
                pessoaId: personId,
                linhaCuidadoId: careLineId,
            }

            await service.detachCareLineFromPerson(body, personId, careLineId);
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}